import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
import cssclass from "./cssclass";
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
const USERNAME=sessionStorage.getItem("USERNAME");
const AD_USER=sessionStorage.getItem("AD_USER");

let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();




const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();


const [allowaddrroles, setAllowaddrroles] = useState({allow:false});
const [userroleopts, setUserroleopts] = useState([]);

const [tblusers, setTblusers] = useState([]);
const [officeopts, setOfficeopts] = useState([]);
const [usergrpoptions, setUsergrpoptions] = useState([]);
const [roleoptions, setRoleoptions] = useState([]);
const [arrayroleid, setArrayroleid] = useState([]);
const [arrayrole, setArrayrole] = useState([]);
const [tblroles, setTblroles] = useState([]);


const [wptusername, setWptusername] = useState({});
const [sessionvaropts, setSessionvaropts] = useState([]);

const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({
	txt:''
	, usergroup:''
	, role: ''
	, custype:''
	, userlocation: ''
	, active: '1'
	});
const [custype, setCustype] = useState([
<option key='custype0' value='' ></option>
,<option key='custype1'  value='Corporate' >Corporate Customers</option>
,<option key='custype2'  value='General' >General Customers</option>
]);



const location = useLocation();


useEffect(() => {

const USERNAME = sessionStorage.getItem("USERNAME")??"";

if (USERNAME==""){
	navigate("/");
	return;
	}//end if

if (officeopts.length==0)
	getwpformoptions();

	//qrylabor();
 },[]);



useEffect(() => {
	if (arrayroleid.length>0 && arrayrole.length>0 && tblusers.length==0)
		gettblusers();
	
 },[JSON.stringify(arrayroleid), JSON.stringify(arrayrole)]);



useEffect(() => {
	document.getElementsByName('txt')[0].focus();
	
 },[JSON.stringify(tblusers)]);

useEffect(() => {

	console.log('wptusername.USERNAME: '+wptusername.USERNAME);//JSON.stringify(webuser)
	if (wptusername.USERNAME!=undefined){
		if (modal.open==false){
			toggleModalsm();
			
			}//end if
			
			
		}//end if
	
 },[wptusername]);

useEffect(() => {
	
	if (arrayroleid.length>0 && arrayrole.length>0)
		gettblusers();
 },[searchcrit]);

function searchcritChange(e){
	
	const {name, value}=e.target;
console.log("searchcritChange name: "+name+' '+value);

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if

async function gettblusers(){

/*
const crit=searchcrit.name=='custype'?'':searchcrit.txt.trim();
const custype=searchcrit.name=='custype'?searchcrit.txt.trim():'';
const userlocation=searchcrit.name=='userlocation'?searchcrit.txt.trim():'';
USER_GRP_ID
*/
let params = searchcrit;
params.USERNAME=sessionStorage.getItem("USERNAME")

console.log("gettblusers: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblusers([]);
  await fetch(resturl+'rarwpform/tblusers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblusers(res) )
      .catch(err => console.log(err));

}//end func

async function getwptuser(e, USERNAME, USER_ID){

e.preventDefault();

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:USERNAME, USER_ID: USER_ID} )
  };		

setTblroles([]);

 await fetch(resturl+'rarwpform/getwptuser',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptuser(res) )
      .catch(err => console.log(err));

}//end func


function aftergetwptuser(res){
if (res.length==undefined)
	return;

let datas={MD:""};
const user=res[0].user;
for(var attributename in user){
		const data=user[attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
console.log("USER_GRP_ID: "+datas.USER_GRP_ID);
console.log("IRD_LOGIN_ID: "+datas.IRD_LOGIN_ID);
setWptusername(datas);

const roleIds=res[0].roleIds;
let htmrows=[];
console.log("arrayroleid: "+JSON.stringify(arrayroleid));
console.log("roleIds: "+JSON.stringify(roleIds));
for (var i=0; i<roleIds.length; i++){
	const x = arrayroleid.indexOf(roleIds[i].ROLE_ID);
	const role = arrayrole[x];
	
	const htmrow=<tr>
		<td align="left">{role}</td>
		</tr>;
	htmrows.push(htmrow);
	}//end for

setTblroles(htmrows);

}//end func


async function getwpformoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		

await  fetch(resturl+'rarwpform/getwpformoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwpformoptions(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwpformoptions(res){

let templocation=[], tempusergrp=[], temprole=[], temparrroleid=[], temparrrole=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	const val=col['VAL'];
	const strOption=""+opt;

	if (combo=='immigoffice' )
		templocation.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='usergroup')
		tempusergrp.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='role'){
		temprole.push(<option key={key} value={val}  >{opt}</option>);
		temparrroleid.push(col['VAL']);
		temparrrole.push(col['OPT']);
		}
		
	
	});//end map
setOfficeopts(templocation);
setUsergrpoptions(tempusergrp);
setRoleoptions(temprole);
setArrayroleid(temparrroleid);
setArrayrole(temparrrole);

//document.getElementsByName('COMPANY')[0].focus();	

}//end func


function rolechanged(e){
	if (e.target.value=="")
		return;
	
	if (!document.getElementById("btngetuserroles"))
		return;
		
	const btngetuserroles=document.getElementById("btngetuserroles");
	
	if (btngetuserroles.classList.contains("hidden")){
		btngetuserroles.classList.remove("hidden");
		console.log("removed btngetuserroles.hidden ")
		}
	else
		console.log("did not remove btngetuserroles.hidden ")
		

}//end func

//

async function getuserroles(e){

e.preventDefault();

if (!document.getElementById("btngetuserroles").classList.contains("hidden"))
	document.getElementById("btngetuserroles").classList.add("hidden");
		
let from_username='';
if (allowaddrroles.allow==true)
	from_username=window.prompt("add roles same as which username? ");

const create_user=from_username==''?0:1;

const params={
	username: wptusername.USERNAME
	, create_user: create_user
	, email: wptusername.EMAIL
	, fullname: wptusername.FULLNAME
	, from_username:from_username
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params)
  };		

setUserroleopts(<option value='1' ></option>);

await  fetch(customspremurl+'rarmssql/get_user_roles',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetuserroles(e, res) )
      .catch(err => console.log(err));

}//end func

function aftergetuserroles(e, res){

setAllowaddrroles({allow:true});
showsnackbar("done!");

let temp=[];
if (!res.length)
	return;

res.map((col, index) => {
	const key="rolesopts_"+index;
	
	temp.push(<option key={key} value={col['roleName']}  >{col['roleName']}</option>);
	
	});//end map

setUserroleopts(temp);
}//end func



async function getusertestdata(e){
	
	e.preventDefault();
	const params={
		USERNAME: sessionStorage.getItem("USERNAME")??""
		, AD_USERNAME: wptusername.USERNAME
		, USER_GRP_ID: wptusername.USER_GRP_ID
	};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
		};		
setDowait({on:true});
cssclass(e.target.id, "hidden", 1);
 await fetch(resturl+'rarwpform/getusertestdata',requestOptions)
      .then(res => res.json())
      .then(res => 	testusername(e, res) )
      .catch(err => console.log(err));	

}//end func

async function testusername(e, res){
	setDowait({on:false});
	cssclass(e.target.id, "hidden", 0);
	const USER_TEST_DATA=res.length?(res[0].USER_TEST_DATA??""):"";
	if (USER_TEST_DATA==""){
		window.alert("abort testusername for empty USER_TEST_DATA");
		return;
		}
	
	const params={
    "USERNAME": wptusername.USERNAME
    ,"PWD": USER_TEST_DATA
    ,"IP": "127.0.0.1"
    ,"FORGOT_PWD": 0
    ,"DEVICE": "Windows"
    ,"EML_VER_CODE": "*wpusers.js#"
    ,"TRUST_CODE": ""
    ,"TRUST_THIS_DEVICE": 0
	};		
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
		};		
setDowait({on:true});
cssclass(e.target.id, "hidden", 1);
await fetch(resturl+'rarwplogin/loginweborgovtuser',requestOptions)
  .then(res => res.json())
  .then(res => aftertestusername(e, res) )
  .catch(err => console.log(err));	
}//end func


function aftertestusername(e, res){
	cssclass(e.target.id, "hidden", 0);
	setDowait({on:false});
	if (res.length==0)
		window.alert("abort aftertestusername for res.length==0");
	else
		loginuser(res[0]);
}//end func





function loginuser(datarow){
	
	
	for(var attributename in datarow){
		const data=datarow[attributename]??"";
		sessionStorage.setItem(attributename, data);
		}//end for	
	
	console.log("sess AUTH_COUNT: "+sessionStorage.getItem("AUTH_COUNT")??"");
	console.log("sess TRUST_COUNT: "+sessionStorage.getItem("TRUST_COUNT")??"");
	console.log("sess START_PAGE: "+sessionStorage.getItem("START_PAGE")??"");

	getSessionvars();	
}//end func



async function getSessionvars(){
const requestOptions = {
  method: 'GET'
};

await fetch(resturl+'rarwplogin/getsessionvars',requestOptions)
  .then(res => res.json())
  .then(res => aftergetSessionvars(res) )
  .catch(err => console.log(err));	
}//end func

async function aftergetSessionvars(res){
//console.log('aftergetSessionvars: '+JSON.stringify(res));
//console.log('aftergetSessionvars res.length: '+res.length);
res.map((col, index) => {
	let val=col['VAL']?col['VAL']:"";
	if (val.toLowerCase()=="null" || val.toLowerCase()=="undefined")
		val="";
	sessionStorage.setItem(col['SESSION_VAR'], val);
	console.log(col['SESSION_VAR']+", "+val);
});		


setFixedSessionItems();

let start_page=sessionStorage.getItem("START_PAGE")??"";

if (start_page=="")
	start_page = "dashboard";


console.log("start_page: "+start_page);
setFixedSessionItems();

/*
	if (cred.cbtrust==1)
		getDeviceName();
	else 
*/
		navigate("/"+start_page);


}//end func

function setFixedSessionItems(){
/*
after login success have a loop to set fixed sessionStorage items to "" if they undefined or null
e.g. IRD_LOGIN_ID, AD_USER
*/
	const arrItm="IRD_LOGIN_ID,AD_USER,TRUSTED_DEVICE,SUP_PVG,TC_ISLAND,PROCESS_AREA,START_PAGE,SHARED_FOLDER".split(",");
	for (var i=0; i<arrItm.length; i++){
		const itm=arrItm[i];
		const currGetItem = ""+(sessionStorage.getItem(itm)??"");
		
		if (currGetItem=="" || currGetItem.toLowerCase().trim()=="null")
			sessionStorage.setItem(itm, "");
		}//end for

	//replace "null" with "" in items
	for (var i = 0; i < sessionStorage.length; i++){
		const key=sessionStorage.key(i);
		//check for null or "null" but no need to check undefined
		if (sessionStorage.getItem(key)==null)
			sessionStorage.setItem(key, "");
		else if (sessionStorage.getItem(key).toLowerCase().trim()=="null")
			sessionStorage.setItem(key, "");
		
		}//end for

}//end func










async function promptNewAduser(e){
	
	e.preventDefault();
	
	const AD_USERNAME = window.prompt("enter TCIG username: ");
	if (!AD_USERNAME)
		return;
	if (AD_USERNAME.trim()=="")
		return;	
/*
if (!EMAIL.includes("@") || !EMAIL.includes("."))
		return;

*/	
	
	const params={
		AD_USERNAME:AD_USERNAME
		, USERNAME:sessionStorage.getItem("USERNAME")
		};
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
		};		

 await fetch(resturl+'rarwpform/addaduser',requestOptions)
      .then(res => res.json())
      .then(res => 	afteraddaduser(res) )
      .catch(err => console.log(err));	

}//end func

function afteraddaduser(res){
	
	let USERNAME="";
	
	if (res.length)
		if (res.length==1)
			USERNAME=res[0].USERNAME;
		
	if (USERNAME=="")
		alert("that failed!");
	else 
		setWptusername((prev)=>{
				return {...prev
				, USERNAME: USERNAME
				, FULLNAME: ""
				, EMAIL: ""
				, IRD_LOGIN_ID: ""
				, TAX_CENTRE_DESC: ""
				, TC_ISLAND: ""
				, CORP_CUSTOMERS:0
				, GNRL_CUSTOMERS:0
				, PRIMARY_AP:0
				, SECONDARY_AP:0
				, SUP_PVG: 0
				, BOARD_REVIEW: 0
				}
			});
	
}//end func

async function getadumd(username){
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {username:username} )
  };		

//await fetch(customspremurl+'rarlogin/getadumd',requestOptions)
  await fetch(resturl+'rarwplogin/getadumd',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetadumd(res) )
      .catch(err => console.log(err));	

}//end func

function aftergetadumd(res){
	if (res.length)
		if (res.length==1)
			setWptusername((prev)=>{
				return {...prev, MD:res[0].MD}
			});
			
}//end func

async function updatewptusername(){

const params={
USERNAME : sessionStorage.getItem("USERNAME")
, wptuser : wptusername
	
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
//USER_GRP_ID
  await fetch(resturl+'rarwpform/updatewptusername',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatewptusername(res) )
      .catch(err => console.log(err));

}//end func


function afterupdatewptusername(res){
	if (res.length==undefined)
		showsnackbar('something went wrong, please try again');
	else{
		showsnackbar('changes were saved successfully');
		
		if (wptusername.USERNAME==sessionStorage.getItem("USERNAME")){
			//if the updated user is logged in then set changes in session
			if (wptusername.TC_ISLAND!="")
				sessionStorage.setItem("TC_ISLAND", wptusername.TC_ISLAND);
			if (wptusername.PROCESS_AREAS!="")
				sessionStorage.setItem("PROCESS_AREA", wptusername.PROCESS_AREAS.includes("C")?"Corporate":"General");
			}//end if
		
		setWptusername((prev)=>{
			return {...prev
				, TAX_CENTRE_DESC:res[0].TAX_CENTRE_DESC??""}
				});
			
		if (sessionStorage.getItem("USERNAME")=="ajones")
			getadumd(wptusername.USERNAME);
		}//end else
		
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;

setUserroleopts([]);
setAllowaddrroles({allow:false});

if (document.getElementById("btngetuserroles"))
	if (document.getElementById("btngetuserroles").classList.contains("hidden"))
		document.getElementById("btngetuserroles").classList.remove("hidden");
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func







async function rptAspNetUsers(e){

e.preventDefault();


const resFilePath="C:\\scripts\\ireports\\out\\APS_User_Roles_Report.pdf";
//2026 08 23 Azure was blocking and got it fixed in PostMan by changing && to &

const paramsurl="reportfilepath=C:\\scripts\\ireports\\rptAspNetUsers.jasper"+
				"&resultfilepath="+resFilePath+
				"&lsargs=TC_ISLAND"+
				"&lsvals="+searchcrit.userlocation;
				
				//note: lsvals and lsargs are comma separated values lists

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {paramsurl:paramsurl} )
  };		

cssclass(e.target.id, "hidden", 1);

 await fetch(resturl+'rarwpform/jaspertopdf',requestOptions)
 	.then(res => res.json())
      .then(res => 	afterrptAspNetUsers(res, e) )
      .catch(err => console.log(err));


}//end func


async function afterrptAspNetUsers(res, e){

cssclass(e.target.id, "hidden", 0);


const strFile=res.length?(res[0].File??""):"";

if (strFile=="")
	window.alert("Error: No file was returned from the server");
else{
	//console.log("strFile: "+strFile);
	const downloadLink = document.createElement("a");
	downloadLink.href = 'data:application/octet-stream;base64,' + strFile;
	downloadLink.download = "APS_User_Roles_Report.pdf"
	downloadLink.click();
	}
	
	
}//end func





function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func


function aftergettblusers(res){
	
if (!res.length)
	return;
	
console.log('aftergettblusers, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	const USERNAME=col['USERNAME'];
	const trkey='tr_'+index;
	const rdkey='td_'+index;
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='center' >{col['USER_GRP']}</td>
	<td align='center' >{col['USERNAME']}</td>
	<td align='center' >{col['INITIALS']}</td>
	<td align='left' ><a href="#" className="nodecor" onClick={(e)=>{getwptuser(e, USERNAME, col['USER_ID']);}}><img src="img/folderyel.png"  height='18'  border="0" /> {col['FULLNAME']}</a></td>
	<td align='center' >{col['EMAIL']}</td>
	<td align='center' >{col['IRD_LOGIN_ID']}</td>
	<td align='center' >{col['CORP_CUSTOMERS1']}</td>
	<td align='center' >{col['GNRL_CUSTOMERS1']}</td>
	<td align='center' >{col['LCODE']}</td>
	<td align='center' ><a href="#" onClick={(e)=>{wptuserroles(e, USERNAME);}} ><img src="img/user_secur.png" height="16" border="0" /></a></td>
	
	</tr>;
	htmrows.push(htmrow);
	

});

setTblusers(htmrows);
}//end func


function wptuserroles(e, username){
e.preventDefault();
window.alert("This feature not ready yet");	
}//end func

function wptusernameChange(e){
//const val=e.target.value;
console.log('e.target.value: '+e.target.value)
const {name, value}=e.target;

if (name=='PROCESS_AREAS'){
	setWptusername((prev) => {
	return {
		...prev
		, GNRL_CUSTOMERS:value.includes('G')?1:0
		, CORP_CUSTOMERS:value.includes('C')?1:0
		, 'PROCESS_AREAS':value
		}
	});		
	}//end if
if (name=='PROCESS_LEVELS'){
	setWptusername((prev) => {
	return {
		...prev
		, PRIMARY_AP:value.includes('P')?1:0
		, SECONDARY_AP:value.includes('S')?1:0
		, 'PROCESS_LEVELS':value
		}
	});		
	}//end if
else
	setWptusername((prev) => {
	return {...prev, [name]:value}
	});	
}//end func

function clearTaxCentre(e){
	e.preventDefault();
const confd=window.confirm("clear the tax centre?\r\nThe IRD user info will be reset when you update user");	
if (!confd)
	return;

	setWptusername((prev) => {
	return {...prev, "TAX_CENTRE_DESC":""}
	});	
}//end func

function loadsessionvaropts(e){
	e.preventDefault();

if (e.target.checked==false){
	setSessionvaropts([]);
	return;
	}
	

let temp=[];
for (var i = 0; i < sessionStorage.length; i++){
	const key=sessionStorage.key(i);
	const displayopt=key+" "+sessionStorage.getItem(key);
    temp.push(<option key={key}  >{displayopt}</option>);
	//console.log("displayopt: "+displayopt);
	}//end for

setSessionvaropts(temp);
}//end func


const yesnooptions = <>
		<option value="0" >No</option>
		<option value="1" >Yes</option>
		</>;
	
	
const SUP_PVG=sessionStorage.getItem("SUP_PVG");
let combosuppvg=<></>;


if (SUP_PVG==1)
		combosuppvg=<>
			<td align='right' >Supervisor:</td>
			<td align='left' >
			<select name='SUP_PVG' value={wptusername.SUP_PVG} onChange={(e)=>{wptusernameChange(e);}} >
			{yesnooptions}
			</select>
			&nbsp;&nbsp;
					<select name="ACTIVE" value={wptusername.ACTIVE} onChange={(e)=>{wptusernameChange(e);}} >
					<option value='1' >Yes</option>
					<option value='0' >No</option>
					</select>
			
			</td>
			<td align='center' >&nbsp;</td>
			<td align='right' >Group:</td>
			<td align='left' >
			<select name='USER_GRP_ID' value={wptusername.USER_GRP_ID} onChange={(e)=>{wptusernameChange(e);}} style={{width:"125px"}} >
			<option value='' ></option>
			{usergrpoptions}
			</select>
			</td>
			</>;

  return (
    <>
	
	
<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >System Users</p>	
	
<table align='center' style={{marginTop:"10px", marginBottom:"10px"}} cellSpacing="0" cellPadding="0" >
<tbody>
	<tr>
	<td align='right' >search criteria:&nbsp;</td>
	<td align='left' ><input name='txt' defaultValue={searchcrit.txt} onChange={(e)=>{searchcritChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='username or email address' /></td>
	</tr>
	<tr>
	<td align='right' >role:&nbsp;</td>
	<td align='left' >
		<select name='role' value={searchcrit.role} onChange={(e)=>{searchcritChange(e);}} ><option value=''></option>{roleoptions}</select>
	</td>
	</tr>
	<tr>
	<td align='right' >customer type:&nbsp;</td>
	<td align='left' >
		<select name='custype' value={searchcrit.custype} onChange={(e)=>{searchcritChange(e);}} >{custype}</select>
		&nbsp;&nbsp;Active: <select name='active' value={searchcrit.active} onChange={(e)=>{searchcritChange(e);}} ><option value='1'>Yes</option><option value='0'>No</option></select>
	</td>
	</tr>
	<tr>
	<td align='right' >location:&nbsp;</td>
	<td align='left' ><select name='userlocation' value={searchcrit.userlocation} onChange={(e)=>{searchcritChange(e);}} ><option value='' ></option>{officeopts}</select></td>
	</tr>
	<tr>
	<td align='right' ></td>
	<td align='left' >
		<a href="#" className="nodecor" onClick={(e)=>{ promptNewAduser(e); }} ><img src="img/addbutton.png" border="0" /> add new username</a>
		{
		AD_USER=="ajones" && <>
		<br/>
		<a href="#" className="nodecor" id="btn_rptAspNetUsers" onClick={(e)=>{rptAspNetUsers(e);}} ><img src="img/pdf.gif" border="0"  /> Users and Roles Report</a>
		</>
		}
	</td>
		
	</tr>


</tbody>
</table>
	
	<table align='center' className='customers' style={{width:"75%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>group</th>
		<th>username</th>
		<th>initials</th>
		<th>full name</th>
		<th>email</th>
		<th>vouchers user</th>
		<th>corp<br/>customers</th>
		<th>genrl<br/>customers</th>
		<th>location</th>
		<th>roles</th>
	</tr>
	</thead>
	<tbody>
		{tblusers}
	</tbody>
	</table>



<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			<table align='center'>
			<tbody>

			<tr>
			<td align='right' >Username: </td>
			<td align='left' >
			<input name='USERNAME' size="9" defaultValue={wptusername.USERNAME} onChange={(e)=>{wptusernameChange(e);}}  readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}} />
			&nbsp;&nbsp;In'ls:
			<input name="INITIALS" size="3" value={wptusername.INITIALS} onChange={(e)=>{wptusernameChange(e);}}  onFocus={(e)=>{e.target.select();}} autoComplete='off' placeholder='Initials'  />
			
			</td>

			<td align='center' >&nbsp;</td>
			<td align='right' >Location: </td>
			<td align='left' >
			<select name='TC_ISLAND' value={wptusername.TC_ISLAND} onChange={(e)=>{wptusernameChange(e);}} style={{width:"125px"}}  >
			<option value='' ></option>
			{officeopts}
			</select>
			
			</td>			
			
			</tr>
			<tr>
			<td align='right' >Email: </td>
			<td align='left' ><input name='EMAIL' value={wptusername.EMAIL} onChange={(e)=>{wptusernameChange(e);}} onFocus={(e)=>{e.target.select();}} autoComplete='off'  /></td>

			<td align='center' >&nbsp;</td>
			<td align='right' >Areas: </td>
			<td align='left' >
				<select name='PROCESS_AREAS' value={wptusername.PROCESS_AREAS}  onChange={(e)=>{wptusernameChange(e);}} style={{width:"125px"}}  >
				<option value=''></option>
				<option value='G'>General Only</option>
				<option value='C'>Corporate  Only</option>
				<option value='GC'>General & Corporate</option>
				</select>
			</td>
			</tr>
			<tr>
			<td align='right' >Full Name: </td>
			<td align='left' ><input name='FULLNAME' value={wptusername.FULLNAME}  onChange={(e)=>{wptusernameChange(e);}} autoComplete='off' placeholder='full name' onFocus={(e)=>{e.target.select();}} /></td>

			<td align='center' >&nbsp;</td>
			<td align='right' >Levels: </td>
			<td align='left' >
				<select name='PROCESS_LEVELS' value={wptusername.PROCESS_LEVELS}  onChange={(e)=>{wptusernameChange(e);}} style={{width:"125px"}} >
				<option value=''></option>
				<option value='P'>Customer Service Only</option>
				<option value='S'>Labour Only</option>
				<option value='PS'>Customer Service & Labour</option>
				</select>
			</td>
			</tr>
			<tr>
			<td align='right' title={wptusername.IRD_LOGIN_ID} >Voucher User: </td>
			<td align='left' >
				<input name='IRD_LOGIN_ID' value={wptusername.IRD_LOGIN_ID} size="13" onChange={(e)=>{wptusernameChange(e);}} autoComplete='off' placeholder='Voucher User' onFocus={(e)=>{e.target.select();}} />
				&nbsp;
				<input name='TAX_CENTRE_DESC' value={wptusername.TAX_CENTRE_DESC} size="7"  readOnly className="gnsbro" title='IRD Tax Centre' placeholder='Tax Centre' onFocus={(e)=>{e.target.select();}} />
			</td>

			<td align='center' >&nbsp;</td>
			<td align='right' >Board: </td>
			<td align='left' >
			<select name='BOARD_REVIEW' value={wptusername.BOARD_REVIEW} onChange={(e)=>{wptusernameChange(e);}} >
			<option value='' ></option>
			{yesnooptions}
			</select>
			&nbsp;(Member)
			</td>


			</tr>


			


			<tr>
			{combosuppvg}
			</tr>
			

			{/*
			wptusername.MD!=""	&&
			<tr>
			<td align='right' >MD: </td>
			<td align='left' ><input defaultValue={wptusername.MD}  readOnly className="gnsbro" /></td>
			</tr>
			
			*/}
			<tr>
			<td align='right' ><a href="#" onClick={(e)=>{clearTaxCentre(e);}} ><img src="img/nok.gif" /> tax centre</a></td>
			<td align='left' >
			{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.on && <button className="button" id='btnupdate' onClick={(e)=>{updatewptusername(e);}} >update this user</button>}
			</td>
			<td align='center' >&nbsp;</td>			
			<td align='left' >
				
				</td>
			<td align='center' >
				{USERNAME=="ajones" && <button className="button" id='btntestusername' onClick={(e)=>{getusertestdata(e);}} >test this user</button>}
			</td>			
			</tr>

	
			<tr valign="top" >
				<td align='right' >last modified:</td>
				<td align='left' >
				 {wptusername.MODIFY_USER+" "+wptusername.MODIFY_DATE1}
				</td>
				<td align='center' >&nbsp;</td>			
				<td align='right' >Roles:</td>
				<td align='left' >
					<table align="center" className="customers" >
					<tbody>
					{tblroles}
					</tbody>
					</table>				
				</td>			
			</tr>	
			<tr>
			<td align='right' >
				<input type="checkbox" id="cbsession" onClick={(e)=>{loadsessionvaropts(e);}} />
				<label htmlFor="cbsession" className="hand"  >session: </label>
				</td>
			<td align='left' >
				<select style={{width:"150px"}} >
				<option value=''  > * * * </option>
				{sessionvaropts}
				</select>
			</td>
			
			<td align='center' >&nbsp;</td>
			<td align='right' >&nbsp;</td>			
			
			</tr>	

			</tbody>
			</table>
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;